import React from 'react'

function CMDhelp() {
  return (
    <div className='text-[0.8rem] text-[gray] ml-1'>
        <span className='ml-1'>currently available commands are :</span> <br />
        → Abolfazl cyrus-coin <br />
        → Abolfazl yola <br />
        → Abolfazl abolfazl-note <br />
        → Abolfazl dandanino <br />
        → Abolfazl clear <br />
        → Abolfazl help <br />
        → Abolfazl shutdown <br /> 
    </div>
  )
}

export default CMDhelp